import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import Keycloak from 'keycloak-js';
import { LoggingService } from '../services/shared/logging/logging.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly keycloak = inject(Keycloak);
  private readonly loggingService = inject(LoggingService);

  constructor() { }

  async canActivate(): Promise<boolean> {
    try {
      this.loggingService.debug('AuthGuard', 'canActivate called');

      const isAuthenticated = this.keycloak.authenticated;
      this.loggingService.debug('AuthGuard', 'Is authenticated:', isAuthenticated);

      if (isAuthenticated) {
        this.loggingService.info('AuthGuard', 'User is authenticated, allowing access');
        return true;
      } else {
        this.loggingService.info('AuthGuard', 'User is not authenticated, redirecting to Keycloak');
        await this.keycloak.login();
        return false;
      }
    } catch (error) {
      this.loggingService.error('AuthGuard', 'Error occurred:', error);
      await this.keycloak.login();
      return false;
    }
  }
}
